import { createReducer, on } from '@ngrx/store';
import { ApartmentState } from './apartment.state';
import { GotApartmentsByBuildingIdEvent, DeletedApartmentEvent } from './apartment.events';

const initialState: ApartmentState = {
  entities: []
};

export const apartmentReducer = createReducer(
  initialState,
  on(GotApartmentsByBuildingIdEvent, (state, { entities }) => ({
    ...state,
    entities
  })),
  on(DeletedApartmentEvent, (state, { apartmentId }) => ({
    ...state,
    entities: state.entities.filter(apartment => apartment.id !== apartmentId)
  }))
);